module.exports = __webpack_public_path__ + "c19551bb.svg";